import merge from 'lodash/merge'
import {media} from './breakpoints'
/* 

  Helper function, meant to be used in styles functions 

  @argument 1: Responsive object
  @argument 2: Either a parser, which receives the responsive value and returns an object with keys or
  a prop. 

  example 1, no custom parser:
  jss: {
    '& .button': {
      ...parseResponsiveProperty('background', responsiveObj)
    }
  }

  example 2, custom parser: 
  jss: {
    '& .button': {
      ...parseResponsiveProperty((v) => ({
        width: v.amount + v.unit
      }), responsiveObj)
    }
  }

  We assume parser returns an object which can be spread in jss = {}

*/


export default function(parserOrProp, props = {}) {

  const { mobile, tablet, desktop } = props

  const parser = typeof parserOrProp === 'string' ? (prop, device) => ({
    [parserOrProp]: prop
  }) : parserOrProp

  const jss = {}

  if (typeof desktop !== 'undefined') {
    merge(jss, parser(desktop, 'desktop'))
  }

  if (typeof tablet !== 'undefined') {
    merge(jss, {
      [media.tablet]: parser(tablet, 'tablet')
    })
  }

  if (typeof mobile !== 'undefined') {
    merge(jss, {
      [media.mobile]: parser(mobile, 'mobile')
    })
  }

  return jss
}